module.exports = __webpack_public_path__ + "static/media/status-success.4b5b05af.svg";